export enum Direction {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
